import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { readConsent, saveConsent, loadAnalytics, OPEN_EVENT } from "../utils/analytics";
import "../styles/cookie.css";

export const CookieBanner = () => {
  const [open, setOpen] = useState(() => !readConsent());

  useEffect(() => {
    if (readConsent() === "all") loadAnalytics();
    const reopen = () => setOpen(true);
    window.addEventListener(OPEN_EVENT, reopen);
    return () => window.removeEventListener(OPEN_EVENT, reopen);
  }, []);

  if (!open) return null;

  const choose = value => {
    saveConsent(value);
    setOpen(false);
  };

  return (
    <div className="sa-cookie" role="region" aria-label="Бисквитки">
      <p className="sa-cookie-text">
        Използваме бисквитки за входа в профила и чата. С ваше съгласие ползваме и
        Google Analytics, за да знаем колко хора посещават сайта и кои страници
        харесват.{" "}
        <Link to="/privacy">Политика за поверителност</Link>
      </p>
      <div className="sa-cookie-actions">
        <button type="button" className="sa-btn sa-btn--primary sa-btn--sm" onClick={() => choose("all")}>
          Приемам
        </button>
        <button type="button" className="sa-btn sa-btn--outline sa-btn--sm" onClick={() => choose("necessary")}>
          Отказвам
        </button>
      </div>
    </div>
  );
};
